import { QueryClient } from '@tanstack/react-query';
import { type DatasourceId, type NetworkId } from '../../types';
import { apiClient } from '../apiClient';

export const fetchMeasurementCsv = async (
  client: QueryClient,
  datasourceId: DatasourceId,
  networkId: NetworkId
): Promise<string> => {
  return await client.fetchQuery({
    queryKey: ['datasource-measurements-csv', datasourceId],
    queryFn: async () => {
      const response = await apiClient.get(`/v1/datasources/${datasourceId}/measurements.csv`, {
        params: {
          networkId: networkId,
        },
      });
      return response.data;
    },
    retry: false,
  });
};
